import React, {FC} from 'react';
import {Flex} from '@priority-software/priority-style-react';
import styles from './ColorPicker.module.scss';
import {routeColors} from '../../constants';
import {ColorTile} from './ColorTile';

export type ColorPickerProps = {
    onSelect: (color: string) => void;
    tileClassName?: string;
};

export const ColorPicker: FC<ColorPickerProps> = ({onSelect, tileClassName}) => {
    return (
        <Flex
            componentClasses={styles.container}
            alignItems={'flex-start'}
            justifyContent={'flex-start'}
        >
            {routeColors.map(color => (
                <ColorTile
                    onClick={() => onSelect(color)}
                    tileClassName={tileClassName}
                    key={color}
                    color={color}
                />
            ))}
        </Flex>
    );
};
